var E;(function(E){E[E["OVERLAY"]=0]="OVERLAY";E[E["CENTERED"]=1]="CENTERED"})(E||(E={}));export{E as EModalMode};
//# sourceMappingURL=enums.js.map
